import { exec } from "@kakaopay-common/payweb-core";
import { INTERFACE } from "../../constants.mjs";
function getSystemStatusHeight() {
  const command = {
    command: INTERFACE.GET_SYSTEM_STATUS_HEIGHT,
    version: {
      ios: {
        talkpay: "9.9.0",
        payapp: "2.12.0",
        bizapp: ""
      },
      android: {
        talkpay: "9.9.0",
        payapp: "2.12.0",
        bizapp: ""
      }
    }
  };
  return exec(command);
}
function getSystemStatusHeightByRatio() {
  const command = {
    command: INTERFACE.GET_SYSTEM_STATUS_HEIGHT,
    version: {
      ios: {
        talkpay: "9.9.0",
        payapp: "2.12.0",
        bizapp: ""
      },
      android: {
        talkpay: "9.9.0",
        payapp: "2.12.0",
        bizapp: ""
      }
    }
  };
  return exec(command).then((res) => {
    if (res.success) {
      res.result.height = res.result.height / window.devicePixelRatio;
    }
    return res;
  });
}
export {
  getSystemStatusHeight,
  getSystemStatusHeightByRatio
};
